module.exports = __webpack_public_path__ + "img/oa_index_banner.56763456.png";